export { PLUGIN_KEY, PLUGIN_PRIORITY, ColumnSorting } from "./columnSorting.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/columnSorting/index.mjs
// module id = 510
// module chunks = 1